const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/AppointmentCards/BookAppointmentCard.tsx';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { goToAppointmentBooking } from 'App/utils/history';
import { DashboardButtonCard } from '../DashboardButtonCard';
import textMapAppointment from 'App/pages/appointment/translations';

export const BookAppointmentCard = (_props: {}): any => {
    const { formatMessage } = useIntl();
    const history = useHistory();

    const handleButtonClick = () => {
        goToAppointmentBooking(history);
    };

    return (
        <DashboardButtonCard iconClass="icons8-calendar" onClick={handleButtonClick}>
            {formatMessage(textMapAppointment.bookAppointment)}
        </DashboardButtonCard>
    );
};
